module.exports = __webpack_public_path__ + "img/073626.417b7c6f.png";